// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// Refactor. There's a lot unnecessary base methods here.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CustomEvent } from '@shared/utils/CustomEvents';
import { ErrorInformationStorage } from '@shared/commons/ErrorInformationStorage';
import { DirectAssetMessage } from '@shared/utils/DirectMessages/DirectMessagesImport';
import { generateReportMessageHandler } from '@shared/utils/AppHandlers';
import EventEmitter from 'events';
export class DirectVendorBase {
    constructor() {
        // #region Constants
        // #endregion
        this.login = null;
        this.userSessionId = null;
        // TODO.
        this.vendorName = '';
        this.OnNewMessage = new CustomEvent();
        this.OnConnected = new CustomEvent();
        // working here
        this.OnConnectionLost = new CustomEvent();
        this.OnError = new CustomEvent();
        this.FAssets = null;
        this._eventEmitter = new EventEmitter();
        // #endregion
    }
    AddConnectedListener(method, context) {
        this.OnConnected.Subscribe(method, context);
    }
    RemoveConnectedListener(method, context) {
        this.OnConnected.UnSubscribe(method, context);
    }
    AddDisconnectedListener(method) {
        this._eventEmitter.on('disconnectedListener', method);
    }
    RemoveDisconnectedListener(method) {
        this._eventEmitter.off('disconnectedListener', method);
    }
    AddConnectionLostListener(method, context) {
        this.OnConnectionLost.Subscribe(method, context);
    }
    RemoveConnectionLostListener(method, context) {
        this.OnConnectionLost.UnSubscribe(method, context);
    }
    AddOnErrorListener(method, context) {
        this.OnError.Subscribe(method, context);
    }
    RemoveOnErrorListener(method, context) {
        this.OnError.UnSubscribe(method, context);
    }
    AddMessageListener(method, context) {
        this.OnNewMessage.Subscribe(method, context);
    }
    RemoveMessageListener(method, context) {
        this.OnNewMessage.UnSubscribe(method, context);
    }
    NotifyListeners(message) {
        this.OnNewMessage.Raise(message);
    }
    GenerateReportMessage(openOrderMessage) {
        const reportMsgArr = generateReportMessageHandler.GenerateReportMessage(openOrderMessage);
        const len = reportMsgArr.length;
        for (let i = 0; i < len; i++) {
            this.NotifyListeners(reportMsgArr[i]);
        }
    }
    Connect(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.ConnectProcessPromise(params)
                .then((connectionResult) => {
                if (!(connectionResult === null || connectionResult === void 0 ? void 0 : connectionResult.Connected)) {
                    return Promise.reject(connectionResult);
                }
                return connectionResult;
            })
                .then((connectionResult) => {
                this.Connected(connectionResult);
                return connectionResult;
            })
                .catch((dataError) => __awaiter(this, void 0, void 0, function* () {
                yield this.Disconnected(dataError);
                void this.DisconnectProcessPromise();
                return dataError;
            }));
        });
    }
    ConnectionLost() {
        this.OnConnectionLost.Raise();
    }
    ErrorOccurred() {
        this.OnError.Raise();
    }
    // #region Trading
    placeOrder(data) { }
    // TODO. Interface. Refactor.
    cancelOrder(order, placedFrom) {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    closePositions(closePositionData, placedFrom) {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    modifyPosition(data) {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    modifyOrder(data) {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    // TODO. Refactor. Move to modifyOrder()?
    changeOrderToMarket(order, placedFrom) {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    // #endregion Trading
    Disconnect(disconnectArguments) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            yield this.Disconnected(disconnectArguments);
            void this.DisconnectProcessPromise((_a = disconnectArguments === null || disconnectArguments === void 0 ? void 0 : disconnectArguments.isNoNActivity) !== null && _a !== void 0 ? _a : false)
                .catch((err) => {
                console.error('Vendor disconnect error: ' + err);
            })
                .then(() => {
                clearInterval(this.crossRatesLoopHandler);
            });
        });
    }
    ParseErrorMessage(text) {
        try {
            const obj = JSON.parse(text);
            if (obj) {
                return obj.message;
            }
        }
        catch (ex) {
            ErrorInformationStorage.GetException(ex);
            return text;
        }
    }
    // TODO. Rename?
    Connected(connectedArguments) {
        this.OnConnected.Raise(connectedArguments);
    }
    // TODO. Rename?
    Disconnected(disconectArguments) {
        return __awaiter(this, void 0, void 0, function* () {
            const listeners = this._eventEmitter.listeners('disconnectedListener');
            const promises = listeners.map((listener) => listener(disconectArguments));
            yield Promise.all(promises);
        });
    }
    // #region Update Object Callbacks
    UpdateAccount(accMsg) {
        this.NotifyListeners(accMsg);
    }
    UpdatePosition(msg) {
        this.NotifyListeners(msg);
    }
    PositionClosedByServer(msg) {
        this.NotifyListeners(msg);
    }
    UpdateOrder(msg) {
        this.NotifyListeners(msg);
        if (msg.OrderStatus !== null) {
            this.GenerateReportMessage(msg);
        }
    }
    NewQuote(msg) {
        this.NotifyListeners(msg);
    }
    AddAsset(currency) {
        if (!currency) {
            return;
        }
        if (this.FAssets == null) {
            this.FAssets = {};
        }
        if (!this.FAssets.hasOwnProperty(currency)) {
            this.FAssets[currency] = this.GetAssetMessage(Object.keys(this.FAssets).length, currency);
            this.NotifyListeners(this.FAssets[currency]);
        }
    }
    GetAssetMessage(id, currency) {
        const am = new DirectAssetMessage();
        am.Id = id;
        am.Name = am.Description = currency;
        am.MinChange = Math.pow(10, -2);
        return am;
    }
    NewTrade(msg) {
        this.NotifyListeners(msg);
    }
    GetRulesTable(account) {
        return {};
    }
    // #endregion For Overriding
    // #region TODO. AuthData idk
    GetVendorName() {
        return this.vendorName;
    }
    GetLogin() {
        return this.login;
    }
    getUserSessionId() {
        return this.userSessionId;
    }
}
DirectVendorBase.DELAY_BETWEEN_CROSSPRICES = 2000;
DirectVendorBase.PFSVendor = 'PFIX';
